module.exports = __webpack_public_path__ + "img/person.02afd40b.png";